import type { JobType } from '@/enum'
import type { ITaskSheet, ITaskSheetSection } from '@/interfaces'
import type { IDocument } from '@/interfaces/IDocument'
import type { ITaskSheetBody } from '@/interfaces/task-sheets/ITaskSheetBody'
import Base from '@/models/Base'
import DocumentModel from '@/models/DocumentModel'
import TaskSheetSection from '@/models/task-sheets/TaskSheetSection'
import TaskSheetBody from './TaskSheetBody'

class TaskSheet extends Base implements ITaskSheet {
  title: string

  description: string

  type: JobType

  header: ITaskSheetSection

  bodies: ITaskSheetBody[]

  footer: ITaskSheetSection

  documents: IDocument[]

  constructor(taskSheet?: any) {
    super(taskSheet)

    this.title = taskSheet?.title ?? ''
    this.description = taskSheet?.description ?? ''
    this.type = taskSheet?.type ?? null
    this.header = new TaskSheetSection(taskSheet?.header, true)
    this.bodies = taskSheet?.bodies?.map((body: any) => new TaskSheetBody(body)) ?? []
    this.footer = new TaskSheetSection(taskSheet?.footer, true)
    this.documents = taskSheet?.documents?.map((document: any) => new DocumentModel(document)) ?? []
  }
}

export default TaskSheet
